import React, {useContext} from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import {makeStyles} from '@material-ui/core/styles';
import routes from '../../routes/pages/default'
import Header from '../../components/shared/layout/header';
import Sidebar from '../../components/shared/layout/sidebar';
import Footer from '../../components/shared/layout/footer';
import RightSidebar from '../../components/shared/layout/rightSidebar';
import {AppContext} from '../../components/shared/context';
import TipoPerfil from "../../constants/tipoPerfil";


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    overflow: 'hidden',
  },
  content: {
    width: '100%',
  },
  mainContent: {
    minHeight: 'calc(100vh - 136px)',
    position: 'relative',
  },

}));

const Default = () => {
  const classes = useStyles();
  const { role } = useContext(AppContext);

  return (
    <>
      {2 > 1
        ? (
          <CssBaseline>
            <Header />
            <div className={classes.root}>
              <Sidebar />
              <div className={classes.content}>
                <div className={classes.mainContent}>
                  <Switch>
                    {routes.map((prop, key) => {
                      if (prop.redirect) {
                        return <Redirect from={prop.path} to={prop.pathTo} key={key} />;
                      }

                      return (
                        <Route exact path={prop.path} component={prop.component} key={key} />
                      );
                    })}
                  </Switch>
                </div>
                <Footer />
              </div>
              {TipoPerfil.EQUIPE_TECNICA.is(role) && <RightSidebar />}
            </div>
          </CssBaseline>
        )
        : 'Você não tem acesso ao sistema'}
    </>

  );
}

export default Default;
